export enum ReactQueryKeys {
  EXERCISES = "exercises",
  WORKOUT_TEMPLATES = "workoutTemplates",
  RECIPE_ALTERNATIVES = "recipeAlternatives",
  CLIENT_VIDEOS = "clientVideos",
}
